import { useHubSwitch } from '@bpm-web-app/utils';
import Script from 'next/script';
import { FC, useMemo } from 'react';

import { Account, AccountPageProps } from '../account';
import IconExternalLink from '../components/icons/external-link.svg';
import { PageHeader } from '../components/page-header/page-header';
import { FAQ } from '../plans/plans/static-content/faq/faq';
import styles from './support.module.css';

type Props = AccountPageProps;

export const AccountSupport: FC<Props> = ({ title }) => {
    const { isArtistPlatform, isCreate } = useHubSwitch();
    const supportLink = useMemo(() => {
        if (isCreate) return 'https://bpmcreate.zendesk.com/hc/en-us';
        if (isArtistPlatform) return 'https://support.bpmsupreme.com/';
        return 'https://support.bpmsupreme.com/';
    }, [isArtistPlatform, isCreate]);

    return (
        <Account title={title}>
            <PageHeader title={title} />
            <h3 className={styles['support__section']}>Frequently Asked Questions</h3>
            <section className={styles['support__section']}>
                <FAQ />
            </section>

            <h3>Still have questions?</h3>
            <p className={styles['support__section']}>
                <a href={supportLink}>Go to BPM Support<IconExternalLink /></a>
            </p>

            <Script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=bef5b9f3-338d-46e0-a9eb-c52898598a98" />
        </Account>
    );
};
